enum ThirdScripts {
  Gtm = 'https://www.googletagmanager.com/gtm.js?id=',
  Dynatrace = 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf20517fnb/7cbaf9836ce996ef_complete.js',
  Recaptcha = 'https://www.google.com/recaptcha/api.js?render=',
  WaitingTime = 0,
}

export default ThirdScripts;
